export enum OrderItemStatus {
  Pending = 'pending',
  ReadyForProduction = 'ready_for_production',
  SendToProduction = 'send_to_production',
  SentToProduction = 'sent_to_production',
}
